/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
import { Row, Col, Button } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const DistrictField = props => {
	// eslint-disable-next-line
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props; // eslint-disable-next-line
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [inputField, setInputField] = useState({
		district: ''
	});

	const [validation, setValidation] = useState({
		error_district: ''
	});

	useEffect(() => {
		if (props.id) {
			const { district } = lodgeData;
			setInputField({ ...inputField, district });
		}
		// eslint-disable-next-line
	}, [props.id]);

	const inputsHandler = e => {
		setCheckDataChange(true);
		setInputField({ ...inputField, [e.target.name]: e.target.value });
	};

	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;

		if (!inputField.district) {
			errors.error_district = pageLanguageContent['CLD071'];
			errorCount++;
		} else {
			errors.error_district = '';
		}
		var sendData = {};
		sendData['value'] = inputField['district'];
		sendData['type'] = 'district';

		setValidation(errors);
		if (errorCount <= 0) {
			setShowLoader(true);
			copiriPortalRequest('/organizations/' + id + '/additional-info', config.app_version, 'patch', sendData)
				.then(response => {
					setShowLoader(false);
					if (response.data.status && response.data.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						closeModal();
						updateLodgeModal('district', inputField['district']);
					}
				})
				.catch(error => {
					toast.error(error.response.data.result);
					setShowLoader(false);
				});
		}
	}

	return (
		<Row className='mt-2'>
			<Col lg={12}>
				<FormGroupInput
					id='district'
					label={pageLanguageContent['CLD157'] ? pageLanguageContent['CLD157'] : ''}
					placeholder={pageLanguageContent['CLD157'] ? pageLanguageContent['CLD157'] : ''}
					type='text'
					name='district'
					onChange={inputsHandler}
					value={inputField.district}
				/>
				{validation.error_district && <p className='formValidationError'>{validation.error_district}</p>}
			</Col>
			<Col lg={12}>
				<Button
					variant='primary'
					id={'confirmValidatebutton'}
					style={{ float: 'right', marginBottom: '15px' }}
					onClick={updateData}
				>
					{showLoader ? (
						<img src={image_loader} alt='loader' height='20' width='20' />
					) : pageLanguageContent['CLD124'] ? (
						pageLanguageContent['CLD124']
					) : (
						''
					)}
				</Button>
			</Col>
		</Row>
	);
};
export default DistrictField;
